<h2 mat-dialog-title>Edit Trust Report Name</h2>

<mat-dialog-content>
  <form [formGroup]="reportForm">
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Report Name</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()">Save</button>
</mat-dialog-actions>
